import {httpAuth} from './config';

export default {
    list: () => {
        return httpAuth.get('v1/group/listar');
    },
}